module.exports = __webpack_public_path__ + "static/media/veg.c830d595.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/veg.svg
// module id = 74
// module chunks = 0